import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { SignatureService } from "./signature";

@Injectable({
  providedIn: "root",
})
export class InterceptorService implements HttpInterceptor {
  constructor(private signature: SignatureService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const method = req.method;
    const path = new URL(req.url, this.signature.getEndpoint()).pathname;
    const headers = req.headers["headers"];
    const params = req.params["map"];
    const body = req.body;

    const clone = req.clone({
      headers: new HttpHeaders(
        this.signature.buildRequestContext(method, path, headers, params, body)
      ),
    });

    return next.handle(clone);
  }
}
